export default "/images/brand-alex.png?40f2b3625e83863238d53a5dee38b3fd";